import { ActivatedRoute } from '@angular/router';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';
import { isRelistPage, isEditPage, isCreatePage } from '../../../helpers/router.helper';

@Component({
    selector: 'property-summary-page-agent-promotions-section',
    templateUrl: './summary-page-agent-promotions-section.component.html',
    styleUrls: ['./summary-page-agent-promotions-section.component.scss']
})
export class SummaryPageAgentPromotionsSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    private _nonPACopy = 'Marketing package';
    private _paCopy = 'Partnership agreement';

    packageCopy = this._nonPACopy;
    packageName: string;
    isRelistPage = false;
    isEditPage = false;
    isCreatePage = false;
    paPackageSelected = false;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _route: ActivatedRoute
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.isRelistPage = isRelistPage(this._route);
            this.isEditPage = isEditPage(this._route);
            this.isCreatePage = isCreatePage(this._route);

            if (this.hasPartnershipAgreement()) {
                const paPackageCode = this.metadata.partnershipAgreementContents.premiumPackages[0].code;
                this.paPackageSelected = this.isCreatePage
                    || (this.originalDraftData.propertyPromote?.packageCode
                        && this.originalDraftData.propertyPromote?.packageCode === paPackageCode);
            }

            this.packageName = this.getPackageName();
            this.packageCopy = this.usePartnershipAgreement()
                ? this._paCopy
                : this._nonPACopy;
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }

    hasPartnershipAgreement(): boolean {
        return (
            (this.metadata.partnershipAgreementContents?.premiumPackages || [])
                .length > 0
        );
    }

    usePartnershipAgreement(): boolean {
        return (this.isCreatePage && this.hasPartnershipAgreement())
            || (this.isEditPage && this.paPackageSelected);
    }

    private getPackageName(): string {
        if (this.usePartnershipAgreement()) {
            return this.metadata.partnershipAgreementContents.premiumPackages[0]
                .name;
        } else {
            const selectedPackage = this.metadata.premiumPackages.find(
                (p) => p.code === this.draftData.propertyPromote.packageCode
            );

            return selectedPackage ? selectedPackage.name : '';
        }
    }
}
